import Sconti from '../../views/orders/Sconti';
import History from '../../views/orders/History';
import Details from '../../views/orders/Details';
import Options from '../../views/orders/Options';
import Summary from '../../views/orders/Summary';

export default [
    {
        path: '/ordine',
        name: 'orders',
        component: Options,
        meta: {
            showNav: true,
            showOptionbar: true,
            headerTitleKey: 'ordine_titolo'
        }
    },
    {
        path: '/ordine/sconti',
        name: 'orders.discounts',
        component: Sconti,
        meta: {
            showNav: true,
            showOptionbar: true,
            headerTitleKey: 'layout_opzioni_label_csconto_tooltip'
        }
    },
    {
        path: '/ordine/storico',
        name: 'orders.history',
        component: History,
        meta: {
            requiresAuth: true,
            showNav: true,
            showOptionbar: true,
            headerTitleKey: 'ordine_storico'
        }
    },
    {
        path: '/ordine/dettaglio/:id',
        name: 'orders.details',
        component: Details,
        meta: {
            requiresAuth: true,
            showNav: true,
            showOptionbar: true,
            headerTitleKey: 'ordine_dettaglio'
        }
    },
    {
        path: '/ordine/riepilogo/:id',
        name: 'orders.summary',
        component: Summary,
        meta: {
            showNav: true,
            showOptionbar: true,
            headerTitleKey: 'ordine_riepilogo'
        }
    },
]
